<script lang="ts">
    import { onMount } from "svelte";
    import { Link, useNavigate } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../store/stores";
    import { usersStore } from "../../../../store/users";
    import Pagination from "./Components/Pagination.svelte";
    import OrganisationCard from "./Components/OrganisationCard.svelte";
    import { organisationStore } from "../../../../store/organisations";

    const navigate = useNavigate();

    const getOrganisations = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .organisationClient.listOrganisations({ size: 17 })
                .then((organisations) =>
                    organisationStore.update((organisationStore) => {
                        return {
                            ...organisationStore,
                            organisations: organisations,
                        };
                    })
                );
        });
    };

    onMount(() => getOrganisations());
</script>

<div class="columns is-multiline">
    <div class="column is-12">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered is-multiline">
                        <div class="column is-1">
                            <p
                                class="is-5 greenish-plus"
                                on:click={() => navigate("new")}
                            >
                                +
                            </p>
                        </div>
                        <div class="column is-4 ">
                            <p class="is-5 greenish">Organisation</p>
                        </div>
                        <div class="column is-4 ">
                            <p class="greenish is-5">Status</p>
                        </div>
                        <div class="column is-2 " />
                        {#if $organisationStore.organisations && $organisationStore.organisations.entries}
                            {#each $organisationStore.organisations.entries as organisation}
                                <OrganisationCard
                                    organisationEntry={organisation}
                                />
                            {/each}
                        {/if}
                        {#if $organisationStore?.organisations?.entries?.length > 20}
                            <Pagination />
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="container top-level">
    <div class="block">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered">
                        <div class="column is-2">
                            <Link to="new" class="new-network-link">
                                <span class="icon has-text-success">
                                    <i class="fas fa-plus" />
                                </span>
                            </Link>
                        </div>
                        <div class="column is-8 centered">
                            <p class="title is-5">Organisation</p>
                        </div>
                        <div class="column is-2">
                            <p class="title is-5">Status</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

</div>

<style>
    .sticky {
        position: sticky;
        top: 0rem;
        z-index: 100;
    }

    .container {
        padding: 0 10px;
        overflow: auto;
        height: calc(84vh);
        margin-top: 1rem;
    }

    .centered {
        text-align: center;
    }
</style> -->
<style>
    .sticky {
        position: sticky;
        top: 0rem;
        z-index: 100;
    }

    .column {
        text-align: center;
    }

    .card {
        border-radius: 100px;
        padding: 1rem;
        padding-bottom: 0;
    }

    .greenish {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }
</style>
